import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { withStyles } from '@material-ui/core/styles'

import CONFIG from '../../config'
import Link from '../controls/Link'

class Footer extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
  }

  static styles = () => ({
    loginFooter: {
      textAlign: 'center',
      fontSize: '12px',
      fontWeight: 400,
      color: '#00000080',
      '& a': {
        color: '#222',
        textDecoration: 'none',
      },
      '& a:hover': {
        textDecoration: 'underline',
      },
    },
  })

  render() {
    const { classes } = this.props

    return (
      <div className={classes.loginFooter}>
        Copyright &copy; {moment().year()} Blokable&reg; Inc. &nbsp;
        <Link to={`${CONFIG.blokable.marketingBaseUrl}/privacy`}>
          Privacy Policy
        </Link>
        &nbsp;&middot;&nbsp;
        <Link to={`mailto:${CONFIG.blokable.supportEmail}`}>
          Support
        </Link>
      </div>
    )
  }
}

export default withStyles(Footer.styles)(Footer)
